var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.cms),expression:"cms"}],class:[_vm.name],style:(_vm.mainCssVars),attrs:{"id":`${_vm.cms.scroll_id}`}},[_c('grid',{class:['grid--container', `${_vm.name}__grid`],attrs:{"layout":[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        rows: 'minmax(73px, auto) 1fr',
        gap: '0 6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        gap: '10px',
      },
    ]}},[_c('grid-item',{class:[`${_vm.name}__grid-item`],attrs:{"layout":[
        { size: 3, x: 1, width: 12 },
        { size: 4, x: 1, width: 7 },
      ]}},_vm._l((_vm.cms.intro),function(item){return _c(item.component,{directives:[{name:"editable",rawName:"v-editable",value:(item),expression:"item"}],key:item._uid,tag:"component",class:`${_vm.name}__intro`,attrs:{"cms":item}})}),1)],1),_vm._v(" "),(_vm.hasContent)?_c('grid',{class:['grid--container', `${_vm.name}__grid`],attrs:{"layout":[
      {
        size: 1,
        columns: 'repeat(12, 1fr)',
        rows: 'minmax(73px, auto) 1fr',
        gap: '0 6px',
      },
      {
        size: 2,
        columns: 'repeat(24, 1fr)',
        gap: '10px',
      },
    ]}},[_c('grid-item',{class:[`${_vm.name}__grid-item`],attrs:{"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 3, x: 1, width: 24 },
        { size: 4, x: 1, width: 7 },
      ]}},[_c('SlideInView',{attrs:{"direction":"up","slide-distance":"100%","threshold":0.1,"repeat":false,"duration":1}},_vm._l((_vm.cms.content_left),function(item){return _c(item.component,{directives:[{name:"editable",rawName:"v-editable",value:(item),expression:"item"}],key:item._uid,tag:"component",class:`${_vm.name}__content-left`,attrs:{"cms":item}})}),1)],1),_vm._v(" "),_c('grid-item',{class:[`${_vm.name}__grid-item`],attrs:{"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 3, x: 1, width: 12 },
        { size: 4, x: 9, width: 7 },
      ]}},[_c('SlideInView',{attrs:{"direction":"up","slide-distance":"100%","threshold":0.1,"repeat":false,"duration":1}},_vm._l((_vm.cms.content_middle),function(item){return _c(item.component,{directives:[{name:"editable",rawName:"v-editable",value:(item),expression:"item"}],key:item._uid,tag:"component",class:`${_vm.name}__content-middle`,attrs:{"cms":item}})}),1)],1),_vm._v(" "),_c('grid-item',{class:[`${_vm.name}__grid-item`],attrs:{"html-tag":`nav`,"layout":[
        { size: 1, x: 1, width: 12 },
        { size: 3, x: 13, width: 12 },
        { size: 4, x: 17, width: 7 },
      ]}},[_c('SlideInView',{attrs:{"direction":"up","slide-distance":"100%","threshold":0.5,"repeat":false,"duration":1}},_vm._l((_vm.cms.content_right),function(item){return _c(item.component,{directives:[{name:"editable",rawName:"v-editable",value:(item),expression:"item"}],key:item._uid,tag:"component",class:`${_vm.name}__content-right`,attrs:{"cms":item}})}),1)],1)],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }